module.exports = __webpack_public_path__ + "img/logo.585ceeb0.png";